import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles/tailwind.css";
import "./styles/index.css";
import { initSentry } from "./utils/sentryService";
import { initObservability } from "./services/observabilityService";

// Initialize Sentry before React renders (HIPAA-safe — PHI scrubbed in beforeSend)
initSentry();

// Initialize observability platforms (Datadog, Dynatrace, Splunk)
initObservability();

const container = document.getElementById("root");
const root = ReactDOM?.createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
